const strip = (html) => (html || "").replace(/<style[\s\S]*?<\/style>|<script[\s\S]*?<\/script>/gi, " ").replace(/<[^>]+>/g, " ").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim();
const has = (text, kw) => !!kw && (text || "").toLowerCase().includes(kw.toLowerCase());
const count = (text, kw) => {
  if (!kw) return 0;
  const esc = kw.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return ((text || "").toLowerCase().match(new RegExp(esc, "g")) || []).length;
};

export const slugify = (s) => (s || "").toLowerCase().trim().replace(/[^\p{L}\p{N}\s-]/gu, "").replace(/\s+/g, "-").replace(/-+/g, "-").slice(0, 80);

export function analyzeSeo({ title = "", metaTitle = "", metaDesc = "", slug = "", html = "", keyword = "", image = "", schema = true }) {
  const kw = keyword.trim();
  const text = strip(html);
  const words = text ? text.split(" ").length : 0;
  const first = strip((html.match(/<p[\s\S]*?<\/p>/i) || [html.slice(0, 600)])[0]);
  const headings = (html.match(/<h[2-3][^>]*>[\s\S]*?<\/h[2-3]>/gi) || []).map(strip);
  const imgs = html.match(/<img[^>]*>/gi) || [];
  const imgsNoAlt = imgs.filter((i) => !/alt\s*=\s*"[^"]+"/i.test(i)).length;
  const links = html.match(/<a\s[^>]*href=/gi) || [];
  const density = words ? (count(text, kw) * kw.split(" ").length * 100) / words : 0;
  const mt = metaTitle || title;
  const kwSlug = slugify(kw);

  const checks = [
    { label: "Focus keyword is set", pass: !!kw, w: 10, tip: "Add a focus keyword to optimise this content." },
    { label: "Keyword in SEO title", pass: has(mt, kw), w: 10, tip: "Use the focus keyword in the SEO title." },
    { label: "SEO title length 30–60 chars", pass: mt.length >= 30 && mt.length <= 60, w: 8, tip: `Currently ${mt.length} characters.` },
    { label: "Keyword in meta description", pass: has(metaDesc, kw), w: 8, tip: "Mention the keyword in the meta description." },
    { label: "Meta description 120–160 chars", pass: metaDesc.length >= 120 && metaDesc.length <= 160, w: 8, tip: `Currently ${metaDesc.length} characters.` },
    { label: "Keyword in URL slug", pass: !!kwSlug && slug.includes(kwSlug), w: 6, tip: "Include the keyword in the slug." },
    { label: "Keyword in first paragraph", pass: has(first, kw), w: 8, tip: "Mention the keyword early in the content." },
    { label: "Keyword in a subheading (H2/H3)", pass: headings.some((h) => has(h, kw)), w: 6, tip: "Use the keyword in at least one H2 or H3." },
    { label: "Keyword density 0.5%–2.5%", pass: density >= 0.5 && density <= 2.5, w: 8, tip: `Currently ${density.toFixed(2)}%.` },
    { label: "Content length 600+ words", pass: words >= 600, w: 10, tip: `Currently ${words} words.` },
    { label: "Uses subheadings", pass: headings.length >= 2, w: 4, tip: "Break content up with H2/H3 headings." },
    { label: "Has links", pass: links.length >= 1, w: 4, tip: "Add internal or external links." },
    { label: "All images have alt text", pass: imgsNoAlt === 0, w: 4, tip: `${imgsNoAlt} image(s) missing alt text.` },
    { label: "Featured / social image set", pass: !!image, w: 4, tip: "Add a featured image for social shares." },
    { label: "Rich schema enabled", pass: !!schema, w: 2, tip: "Enable structured data (schema)." },
  ];
  const total = checks.reduce((a, c) => a + c.w, 0);
  const score = Math.round((checks.reduce((a, c) => a + (c.pass ? c.w : 0), 0) / total) * 100);
  return { score, checks, words, density };
}

export const scoreColor = (s) => (s >= 80 ? "text-emerald-400 border-emerald-400/50" : s >= 50 ? "text-amber-400 border-amber-400/50" : "text-red-400 border-red-400/50");

export const homeHtml = (c) => {
  if (!c) return "";
  const p = (s) => `<p>${s}</p>`;
  return [
    `<h2>${c.hero.h1a} ${c.hero.h1gold} ${c.hero.h1b}</h2>`, p(c.hero.sub),
    `<h2>${c.exchange.title}</h2>`, p(c.exchange.sub),
    `<h2>${c.games.title}</h2>`, p(c.games.sub), ...c.games.items.map((g) => `<h3>${g.title}</h3>${p(g.desc)}`),
    `<h2>${c.how.title}</h2>`, ...c.how.steps.map((s) => `<h3>${s.title}</h3>${p(s.desc)}`),
    `<h2>${c.pay.title}</h2>`, p(c.pay.sub), ...c.pay.features.map((f) => `<h3>${f.title}</h3>${p(f.desc)}`),
    `<h2>${c.faq.title}</h2>`, ...c.faq.items.map((f) => `<h3>${f.q}</h3>${p(f.a)}`),
    `<a href="#">link</a>`,
  ].join("");
};
